import { ContactFull } from 'flow/types/Contact';
import React from 'react';
import ContactAvatar from '../ui-components/ContactAvatar';
import { TypedMap } from 'flow/types/TypedMap';
import IconButton from '../ui-components/IconButton';
import Icon from '../ui-components/Icon';
import useAppContext from 'flow/hooks/useAppContext';
import { twMerge } from 'tailwind-merge';

interface Props {
    contact: TypedMap<ContactFull>;
    contactName: string;
    size: 'large' | 'small';
    handleChat?: () => void;
}

const CoListeningContactItem = ({
    contact,
    contactName,
    size,
    handleChat,
}: Props) => {
    const { i18next } = useAppContext();

    const isLarge = size === 'large';

    return (
        <div
            className={twMerge(
                'flex items-center justify-between truncate rounded-sm bg-gray-700',
                isLarge ? 'm-2 h-15 text-sm' : 'h-9 text-xs',
            )}
        >
            <div className="flex items-center overflow-hidden">
                <div className="m-3 flex items-center">
                    <ContactAvatar
                        contact={contact}
                        size={isLarge ? 'medium' : 'small'}
                    />
                </div>
                <span className="me-3 truncate text-white">{contactName}</span>
            </div>

            {handleChat && (
                <div className="flex items-center pe-3">
                    <IconButton
                        onClick={handleChat}
                        tooltipLabel={i18next.t('Tooltip.Title.SendMessage')}
                        className="size-5 text-white"
                    >
                        <Icon iconKey="chat" />
                    </IconButton>
                </div>
            )}
        </div>
    );
};

export default CoListeningContactItem;
